<template>
  <div>
    <div class="overlayMask" @click="closePopup"></div>
    <div class="salesgear-upgrade-popup">
      <div class="ae-popup-card popup-animate popup-scale-in">
        <div class="ae-title">
          <i class="material-icons closePopup" @click="closePopup">close</i>
          <h4 class="ae-app-name">
            <img src="@/assets/images/salesgearFullLogo.png" />
          </h4>
          <h4>
            Add your email account
          </h4>
        </div>
        <div class="ae-popup-body">
          <p class="ae-desc">
            Before adding contacts to sequences, you must add your email account
            with Salesgear
          </p>
          <div class="btnSection">
            <button
              class="but btnSalesgear wiggle"
              @click="redirectToSalesgearPricing"
              type="button"
            >
              Add Email Account
            </button>
          </div>
        </div>
        <div class="ae-footer">
          <img
            src="@/assets/icons/png/aeAddEmailAccount.png"
            class="connect-email-img"
          />
          <img src="@/assets/icons/png/bgDotted.png" class="bg-dotted" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import shareFunction from '@/assets/util/functions'
import { MxEvent } from '@/assets/util/constants/analytics'
import { SALESGEAR_URL } from '@/assets/util/constants/constants'

export default {
  name: 'SalesgearDuplicateContactPopup',
  components: {},
  props: [],
  data: function() {
    return {
      type: this.expContactType
    }
  },
  computed: {
    expContactType() {
      return this.$store.state.salesgear.expContactType
    }
  },
  methods: {
    closePopup() {
      this.$store.state.salesgear.showConnectEmail = false
    },
    redirectToSalesgearPricing() {
      this.$store.state.salesgear.showConnectEmail = false
      shareFunction.track(
        MxEvent.aeAddEmailAccountClicked,
        { pageType: this.pageType },
        this.$store.state
      )
      window.open(`${SALESGEAR_URL}/settings/account`, '_blank')
    }
  }
}
</script>

<style scoped lang="scss">
.overlayMask {
  @include overlay(rgb(0, 0, 0, 0.85), 10, fixed);
}
.salesgear-upgrade-popup {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  will-change: transform;
  width: 84%;
  max-width: 360px;
  z-index: 11;
  margin: 0 auto;
  .ae-popup-card {
    background: $white;
    color: $text-dark;
    padding: 20px 30px 0;
    border-radius: 6px;
    letter-spacing: 0.3px;
    transition: all 300ms ease;
    @include relBlock;
    will-change: auto;
    .ae-title {
      will-change: auto;
      @include relBlock;
      i {
        position: absolute;
        right: -16px;
        top: -10px;
        will-change: auto;
      }
      h4 {
        line-height: 1.3;
        font-size: 20px;
        margin: 0;
        will-change: font-size;
        padding-top: 10px;
        letter-spacing: 0.5px;
        color: $title-dark;
        padding-bottom: 10px;
        &.ae-app-name {
          padding-top: 0px;
          padding-bottom: 0px;
          margin-bottom: 6px;
          font-size: 16px;
          @include flex-align-path-justify(center, row, flex-start);
          span.text {
            margin-left: 8px;
          }
        }
        img {
          @include wt-ht(108px, auto);
        }
      }
    }
    .ae-popup-body {
      @include relBlock;
      will-change: auto;
      padding: 20px 0;
      .ae-desc {
        margin: 0;
        font-size: 16px;
        will-change: font-size;
        line-height: 1.4;
        padding-bottom: 10px;
      }
      .btnSection {
        @include relBlock;
        padding-top: 20px;
        .btnSalesgear {
          padding: 8px 15px;
          letter-spacing: 0.3px;
          font-size: 16px;
          will-change: font-size;
          &:hover {
            box-shadow: 0px 0px 3px 0px rgba(0, 0, 0, 0.15);
          }
        }
        .about-policy {
          font-size: 14px;
          margin: 6px 0 0;
        }
      }
    }
    .ae-footer {
      @include relBlock;
      margin-top: 10px;
      .connect-email-img {
        @include relBlock;
        width: 110px;
        height: 100%;
        will-change: width;
        margin: 0 0 0 auto;
      }
      .bg-dotted {
        position: absolute;
        height: 100%;
        bottom: 0;
        right: -30px;
        z-index: -1;
      }
    }
  }
}
</style>
